<template>
    <div>
        <!-- Demand Stepper -->
        <v-layout row wrap>
            <v-flex xs10 offset-xs1 md10 offset-md1 lg8 offset-lg2>
                <v-stepper v-model="currentStep">
                    <v-stepper-header class="elevation-0">
                        <!-- attributes are a bit weird (editable, complete, edit-icon), but that's because stepper icon behaviour is weird -->
                        <v-stepper-step step="1" :editable="isDemandEnabled" :complete="isDemandEnabled"
                            :edit-icon="demandIcon">{{ $t("label.request") }}</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="2" :editable="isPlanningEnabled" :complete="isPlanningEnabled"
                            :edit-icon="planningIcon">{{ $t("label.planning") }}</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="3" :editable="isValidationEnabled" :complete="isValidationEnabled"
                            :edit-icon="validationIcon">{{ $t("label.delivery") }}</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="4" :editable="isClosureEnabled" :complete="isClosureEnabled"
                            :edit-icon="closureIcon">{{ $t("label.closure") }}</v-stepper-step>
                    </v-stepper-header>
                    <v-progress-linear v-show="loading" v-bind:indeterminate="true" class="ma-0"></v-progress-linear>
                    <v-divider></v-divider>
                    <div v-show="!loading">
                        <v-card class="elevation-0">
                            <v-card-title>
                                <v-layout row>
                                    <v-flex xs12>
                                        <dl class="details-list">
                                            <dt>{{ $t("label.code") }}</dt>
                                            <dd>{{ code }}</dd>

                                            <dt>{{ $t("label.status") }}</dt>
                                            <dd>{{ status }}</dd>

                                            <!--Exibicao para o status = 9 Encerrada-->
                                            <dt v-if="!showOwner && currentStep == '1' && dtImplementation">
                                                {{ $t("label.dtImplementacao") }}
                                            </dt>
                                            <dd v-if="!showOwner && currentStep == '1' && dtImplementation">
                                                {{ formatDateAndSubtractDays(dtImplementation, qtdDays) }}
                                            </dd>

                                            <dt v-if="!showOwner && currentStep == '4' && dtImplementation">
                                                {{ $t("label.implantacao") }}
                                            </dt>
                                            <dd v-if="!showOwner && currentStep == '4' && dtImplementation">
                                                {{ formatDate(dtImplementation) }}
                                            </dd>
                                            <dt v-if="!showOwner && currentStep == '4' && dtImplementation">
                                                {{ $t("label.garantia") }}
                                            </dt>
                                            <dd v-if="!showOwner && currentStep == '4' && dtImplementation">
                                                {{ formatDateAndSubtractDays(dtImplementation, qtdDays) }}
                                            </dd>
                                            <!--Fim-->


                                            <dt v-if="showOwner">
                                                {{ $t("label.owner") }}
                                            </dt>
                                            <dd v-if="showOwner">
                                                {{ owner }}
                                            </dd>

                                            <!---- Exibicao para o status = 6 Entrega Aprovada - Implantação ---->
                                            <dt
                                                v-if="showOwner && currentStep != '4' && currentStep != '2' && currentStep != '3' && dtImplementation">
                                                {{ $t("label.dtImplementacao") }}
                                            </dt>
                                            <dd
                                                v-if="showOwner && currentStep != '4' && currentStep != '2' && currentStep != '3' && dtImplementation">
                                                {{ formatDateAndSubtractDays(dtImplementation, qtdDays) }}
                                            </dd>
                                            <dt v-if="showOwner && currentStep == '4' && dtImplementation">
                                                {{ $t("label.implantacao") }}
                                            </dt>
                                            <dd v-if="showOwner && currentStep == '4' && dtImplementation">
                                                {{ formatDate(dtImplementation) }}
                                            </dd>
                                            <dt v-if="showOwner && currentStep == '4' && dtImplementation">
                                                {{ $t("label.garantia") }}
                                            </dt>
                                            <dd v-if="showOwner && currentStep == '4' && dtImplementation">
                                                {{ formatDateAndSubtractDays(dtImplementation, qtdDays) }}
                                            </dd>
                                            <!---->

                                            <dt style="margin-left:auto" v-if="
                                                this.$store.getters.demand.status.id == 9 &&
                                                this.$store.getters.demand.scoreAverage !== 0">Média Avaliação</dt>
                                            <dd v-if="
                                                this.$store.getters.demand.status.id == 9 &&
                                                this.$store.getters.demand.scoreAverage !== 0">{{
                                                    this.$store.getters.demand.scoreAverage }}</dd>
                                        </dl>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                        </v-card>
                        <v-divider></v-divider>
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <app-creation></app-creation>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <app-planning></app-planning>
                            </v-stepper-content>
                            <v-stepper-content step="3">
                                <app-delivery></app-delivery>
                            </v-stepper-content>
                        </v-stepper-items>
                    </div>
                </v-stepper>
                <!-- <v-btn @click="$router.go(-1)">Voltar</v-btn> -->
            </v-flex>
        </v-layout>

        <v-layout row wrap v-if="demand.id != 0 && demand.status.id == 6 && currentStep == 3" class="mt-3">
            <v-flex xs10 offset-xs1 lg8 offset-lg2>
                <app-evaluation />
            </v-flex>
        </v-layout>

        <!-- Workflow History Table -->
        <v-layout row wrap v-if="demand.id != 0" class="mt-3">
            <v-flex xs10 offset-xs1 lg8 offset-lg2>
                <app-workflow-history :items="workFlowHistoryForCurrentStep"></app-workflow-history>
            </v-flex>
        </v-layout>

        <!-- Approval -->
        <transition>
            <v-layout row wrap v-if="canApprove" class="mt-3">
                <v-flex xs10 offset-xs1 lg8 offset-lg2>
                    <app-approve :message="approvalMessage"></app-approve>
                </v-flex>
            </v-layout>
        </transition>
    </div>
</template>

<script>
import constants from "@/helpers/constants";
import utilities from "@/helpers/utilities";

import Closure from "./steps/Closure";
import Delivery from "./steps/Delivery";
import Creation from "./steps/Creation";
import Planning from "./steps/Planning";
import WorkflowHistory from "./shared/WorkflowHistory";
import Evaluation from "./shared/Evaluation";
import Approve from "./shared/Approve";

export default {
    // props, data, computed
    data() {
        return {
            loading: true,
            currentStep: "1"
        };
    },
    computed: {
        demand() {
            return this.$store.getters.demand;
        },
        dtImplementation() {
            return this.demand.dtImplementation;
        },
        qtdDays() {
            console.log('qtdDays', this.demand.qtdDays);
            return this.demand.qtdDays;
        },
        code() {
            return utilities.isEmptyOrZero(this.demand.id)
                ? "-"
                : `D${this.demand.code}`;
        },
        owner() {
            const statusId = (this.demand.status || {}).id;
            const supplierId = (this.demand.supplier || {}).id;
            const currentStep = Number(this.currentStep);
            const shouldShowProdam =
                supplierId === 1 &&
                [7].includes(statusId) &&
                !(statusId === 7 && this.demand.dtImplementation);
                // [3, 5, 7].includes(statusId)
                // se necessário, adicionar outros status aqui, como no ex acima
            if (shouldShowProdam) {
                return "Prodam";
            }
            return utilities.isEmptyOrZero(this.demand.id) ? "-" : this.demand.owner.name;
        },
        ownerProdam() {
            return "Prodam";
        },
        status() {
            console.log('Status ID:', this.demand.status && this.demand.status.id);
            if (utilities.isEmptyOrZero(this.demand.id)) {
                return "-";
            }
            if (this.demand.status && !this.demand.dtImplementation &&
             this.demand.status.id === 7 && this.demand.supplier.id === 1) {
                return "Entrega Aprovada - Implantação";
            }
            if (this.demand.status && this.demand.dtImplementation && this.demand.status.id === 7) {
                return "Encerramento - Aguardando conclusão";
            }
            return this.$t("type.status")[this.demand.status.id];
        },

        isDemandEnabled() {
            return true;
        },
        isApprovalEnabled() {
            return this.stepEnabled(constants.STATUS_CREATED_APPROVAL);
        },
        isPlanningEnabled() {
            return this.stepEnabled(constants.STATUS_PLANNING);
        },
        isValidationEnabled() {
            return this.stepEnabled(constants.STATUS_DELIVERY);
        },
        isClosureEnabled() {
            return this.stepEnabled(constants.STATUS_FINALIZING);
        },

        demandIcon() {
            return this.stepIcon(this.isApprovalEnabled);
        },
        approvalIcon() {
            return this.stepIcon(this.isPlanningEnabled);
        },
        planningIcon() {
            return this.stepIcon(this.isValidationEnabled);
        },
        validationIcon() {
            return this.stepIcon(this.isClosureEnabled);
        },
        closureIcon() {
            return this.stepIcon(this.stepEnabled(constants.STATUS_DONE));
        },

        showOwner() {
            return this.demand.status.id < constants.STATUS_REJECTED;
        },

        workFlowHistoryForCurrentStep() {
            const history = this.demand.workflowHistory;

            switch (this.currentStep) {
                case "1":
                    return utilities.filterByStatus(
                        history,
                        constants.STATUS_CREATED,
                        constants.STATUS_REJECTED,
                        constants.STATUS_CREATED_APPROVAL
                    );
                case "2":
                    return utilities.filterByStatus(
                        history,
                        constants.STATUS_PLANNING,
                        constants.STATUS_PLANNING_APPROVAL
                    );
                case "3":
                    return utilities.filterByStatus(
                        history,
                        constants.STATUS_DELIVERY,
                        constants.STATUS_DELIVERY_APPROVAL
                    );
                case "4":
                    return utilities.filterByStatus(
                        history,
                        constants.STATUS_FINALIZING
                    );
                default:
                    return [];
            }
        },
        canApprove() {
            if (
                this.$store.getters.profile.person.id !==
                this.demand.owner.id &&
                (!this.demand.subOwners ||
                    this.demand.subOwners.filter(
                        owner =>
                            owner.id === this.$store.getters.profile.person.id
                    ).length === 0) &&
                !this.$store.getters.isAdmin
            ) {
                return false;
            }


            const hash = {
                [constants.STATUS_CREATED_APPROVAL]: "1",
                [constants.STATUS_PLANNING_APPROVAL]: "2",
                [constants.STATUS_DELIVERY_APPROVAL]: "3",
                [constants.STATUS_FINALIZING]: "4"
            };

            return this.currentStep === hash[this.demand.status.id];
        },
        approvalMessage() {
            const hash = {
                [constants.STATUS_CREATED_APPROVAL]: this.$t(
                    "message.info.demandCreationApproval"
                ),
                [constants.STATUS_PLANNING_APPROVAL]: this.$t(
                    "message.info.demandPlanningApproval"
                ),
                [constants.STATUS_DELIVERY_APPROVAL]: this.$t(
                    "message.info.demandDeliveryApproval"
                ),
                [constants.STATUS_FINALIZING]: this.$t(
                    "message.info.demandFinalizing"
                )
            };

            return hash[this.demand.status.id] || "";
        }
    },

    components: {
        appClosure: Closure,
        appDelivery: Delivery,
        appCreation: Creation,
        appPlanning: Planning,
        appWorkflowHistory: WorkflowHistory,
        appApprove: Approve,
        appEvaluation: Evaluation
    },

    watch: {
        $route: "fetchDemand"
    },

    created() {
        this.$store.dispatch("resetDemand");
        // consulta a demanda selecionada no Grid tela Demadas.
        this.fetchDemand();
    },

    methods: {
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        },
        formatDateAndSubtractDays(dateString, daysToSubtract) {
            const date = new Date(dateString);
            date.setDate(date.getDate() + daysToSubtract + 1);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        },
        stepEnabled(value) {
            return !this.loading && this.demand.status.id >= value;
        },
        stepIcon(isNextStepEnabled) {
            return isNextStepEnabled ? "check" : "edit";
        },
        async fetchDemand() {
            this.currentStep = "1";
            const id = this.$route.params.id;

            if (!utilities.isEmptyOrZero(id)) {
                console.log('Fetching demand with ID:', id);
                await this.$store.dispatch("fetchDemand", id);
            }

            this.loading = false;
        }
    }
};
</script>

<style scoped>
.details-list {
    display: flex;
    flex-wrap: wrap;
    /* allow items to wrap to the next line */
    align-items: center;
    gap: 8px 16px;
    /* spacing between items */
    white-space: normal;
    /* enable wrapping of long content */
}

.details-list dt,
.details-list dd {
    margin: 0;
    /* reset default margins */
}

/* Make dt/dd appear as pairs and wrap nicely */
.details-list dt {
    font-weight: 600;
}

.details-list dd {
    margin-right: 24px;
}

/* Optional: ensure very long values can break */
.details-list dd {
    word-break: break-word;
}

.card__title {
    height: auto;
    padding: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/demands/Edit.vue